import axios from 'axios'
import { useEffect, useState } from 'react'
import WeatherIcon from '../assets/icons/weather/WeatherIcons'
import { ReactComponent as HighIcon } from '../assets/icons/weather_icons/high-icon.svg'
import { ReactComponent as HumidityIcon } from '../assets/icons/weather_icons/humidity-icon.svg'
import { ReactComponent as LowIcon } from '../assets/icons/weather_icons/low-icon.svg'
import { ReactComponent as PressureIcon } from '../assets/icons/weather_icons/pressure-icon.svg'
import { ReactComponent as WindIcon } from '../assets/icons/weather_icons/wind-icon.svg'
import { PageLoader } from '../components/ui/Spinner/Spinner'
import '../styles/shared.scss'
import './Weather.scss'

const dayNames = [
  'Domingo',
  'Lunes',
  'Martes',
  'Miércoles',
  'Jueves',
  'Viernes',
  'Sábado',
]

export const Weather = () => {
  const [weatherData, setWeatherData] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchWeather = async () => {
      try {
        const res = await axios.get(
          'https://www.el-tiempo.net/api/json/v2/provincias/29/municipios/29008'
        )
        setWeatherData(res.data)
      } catch (error) {
        console.error('Error fetching weather', error)
      }
      setLoading(false)
    }
    fetchWeather()
  }, [])

  if (loading)
    return (
      <div className="loading-center">
        <PageLoader />
      </div>
    )
  if (!weatherData)
    return <p className="empty-state">No se pudo cargar el clima</p>

  const current = weatherData.stateSky || {}
  const temp = weatherData.temperaturas || {}
  const humidity = weatherData.humedades || {}
  const forecast = weatherData.pronostico?.hoy || {}
  const nextDays = weatherData.proximos_dias || []

  return (
    <div className="page-container weather-page">
      <h2 className="page-title">Clima en Málaga</h2>

      {/* Current Weather */}
      <div className="weather-current">
        <div className="weather-current__icon">
          <WeatherIcon code={current.id} big />
        </div>
        <div className="weather-current__info">
          <span className="weather-current__temp">{temp.max}°</span>
          <span className="weather-current__desc">
            {current.description || current.descripcion || '—'}
          </span>
          <div className="weather-current__range">
            <span>
              <HighIcon width={16} height={16} /> {temp.max}°
            </span>
            <span>
              <LowIcon width={16} height={16} /> {temp.min}°
            </span>
          </div>
        </div>
      </div>

      {/* Details */}
      <div className="weather-details">
        <div className="weather-detail-item">
          <HumidityIcon width={24} height={24} />
          <span className="weather-detail-item__label">Humedad</span>
          <span className="weather-detail-item__value">
            {humidity.max || '—'}%
          </span>
        </div>
        <div className="weather-detail-item">
          <WindIcon width={24} height={24} />
          <span className="weather-detail-item__label">Viento</span>
          <span className="weather-detail-item__value">
            {forecast.viento?.velocidad || '—'} km/h
          </span>
        </div>
        <div className="weather-detail-item">
          <PressureIcon width={24} height={24} />
          <span className="weather-detail-item__label">Sens. Térmica</span>
          <span className="weather-detail-item__value">
            {weatherData.sensTermica?.max || '—'}°
          </span>
        </div>
      </div>

      {/* Forecast */}
      <h3 style={{ margin: '1.5rem 0 1rem', fontWeight: 700 }}>
        Próximos días
      </h3>
      <div className="weather-forecast">
        {nextDays.slice(0, 6).map((day, i) => {
          const date = new Date(day['@attributes']?.fecha || day.fecha)
          const dayTemp = day.temperatura || {}
          const daySky =
            day.estado_cielo_descripcion ||
            day.estado_cielo?.[0]?.descripcion ||
            ''
          const skyId = day.estado_cielo?.[0]?.id || day.estado_cielo_id
          return (
            <div key={i} className="weather-forecast-card">
              <span className="weather-forecast-card__day">
                {dayNames[date.getDay()] || `Día ${i + 1}`}
              </span>
              <WeatherIcon code={skyId} />
              <span className="weather-forecast-card__temp">
                {dayTemp.maxima || dayTemp.max || '—'}° /{' '}
                {dayTemp.minima || dayTemp.min || '—'}°
              </span>
              <span className="weather-forecast-card__desc">{daySky}</span>
            </div>
          )
        })}
      </div>
    </div>
  )
}
